import { DefaultTheme } from "styled-components";
import qualiredeLogo from "./logo.png";
import { tint } from "polished";

export const qualiredeTheme: DefaultTheme = {
  title: "qualirede",

  colors: {
    primary: "#524FA1",
    secondary: "#FDB913",
    chatMessage: "#524FA1",
    header: "#524FA1",
    background: tint(0.3, "#524FA1"),
  },

  images: {
    logo: qualiredeLogo,
    background: "",
  },
};
